import { Component, Input, OnInit } from '@angular/core';
import { ShareDto } from 'src/app/api/models';
import { IonBadge } from "@ionic/angular/standalone";
import { IconComponent } from "../../../../../../../shared/components/elements/icon/icon.component";
import { DatePipe, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'vl-booking-access-item',
	templateUrl: './booking-access-item.component.html',
	styleUrls: ['./booking-access-item.component.scss'],
 imports: [IconComponent, IonBadge, DatePipe, TranslatePipe, NgIf],
})
export class BookingAccessItemComponent implements OnInit {
	@Input() bookingAccessItem: ShareDto

	constructor() {
	}

	ngOnInit() {
	}
}
